import { render, staticRenderFns } from "./preview-permission.vue?vue&type=template&id=1c87f882&scoped=true&"
import script from "./preview-permission.vue?vue&type=script&lang=js&"
export * from "./preview-permission.vue?vue&type=script&lang=js&"
import style0 from "./preview-permission.vue?vue&type=style&index=0&id=1c87f882&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c87f882",
  null
  
)

export default component.exports